<template>
  <div class="details">
    <QS-scroller-box>
      <!-- 详情页 -->
      <div class="details_content">
        <div class="details_content_title">
          <QS-h3-title class="purchase">
            <template slot="title">企业租赁订单详情</template>
          </QS-h3-title>
        </div>
        <div class="splitline mt16 mb16" />
        <!-- --开始------订单信息------------- -->
        <div class="details_content_repeat">
          <div>
            <QS-h4-title title="企业订单信息" >
            </QS-h4-title>
          </div>
          <div class="details_content_repeat_hundred">
            <el-form label-width="102px" >
              <column-box :source="baseInfo" :list="baseInfoList" :labelWidth="140">
                <el-form-item
                  :label="'合同附件' + columnSeparator"
                  prop="contractAttachment"
                  class="enclosure alone"
                >
                  <div v-if="isEdit">
                    <UploadCommon
                      :fileList="baseInfo.contractAttachment"
                      :limit="20"
                      :drag="true"
                      listType="text"
                      :sizeType="4"
                    ></UploadCommon>
                  </div>
                  <div v-else>
                    <div v-if="this.baseInfo.contractAttachment">
                      <div
                        v-for="(item, index) in this.baseInfo.contractAttachment"
                        :key="'baseInfo' + index"
                        class="uptext"
                      >
                        <p
                          v-down="{ url: item.url, name: item.name }"
                          class="blue"
                        >
                          <i class="el-icon-document blue"></i>
                          {{ item.name }}
                        </p>
                      </div>
                    </div>
                    <div v-else>--</div>
                  </div>
                </el-form-item>
              </column-box>
            </el-form>
          </div>
        </div>
        <!-- --结束------采购订单基本信息------------- -->

        <!-- --开始------原订单信息------------- -->
        <div class="details_content_repeat" v-for="(item, index) in oldEntOrderInfoes" :key="index">
          <div>
            <QS-h4-title :title="item.gmtCreate ? `原企业订单信息-${item.gmtCreate}` : '原企业订单信息'" >
            </QS-h4-title>
          </div>
          <div class="details_content_repeat_hundred">
            <el-form label-width="102px" >
              <column-box :source="item" :list="oldEntOrderInfoList">
                <el-form-item
                  :label="'合同附件' + columnSeparator"
                  prop="contractAttachment"
                  class="enclosure alone"
                >
                  <div>
                    <div v-if="item.contractAttachment">
                      <div
                        v-for="(item, index) in item.contractAttachment"
                        :key="'baseInfo' + index"
                        class="uptext"
                      >
                        <p
                          v-down="{ url: item.url, name: item.name }"
                          class="blue"
                        >
                          <i class="el-icon-document blue"></i>
                          {{ item.name }}
                        </p>
                      </div>
                    </div>
                    <div v-else>--</div>
                  </div>
                </el-form-item>
              </column-box>
            </el-form>
          </div>
        </div>
        <!-- --结束------原订单信息------------- -->

        <!-- --开始------车辆信息------------- -->
        <car-info :payInfo="baseInfo"></car-info>
        <!-- --结束------车辆信息------------- -->

        <!-- 付款单信息 -->
        <detail-payment-info :payInfo="baseInfo"></detail-payment-info>

        <!-- 收款单信息 -->
        <detail-receivable-info :payInfo="baseInfo"></detail-receivable-info>
      </div>
      <template slot="bottomAction" v-if="isEdit">
        <el-button
          size="small"
          type="primary"
          @click="doSave"
          :loading="btnLoading"
          >保存修改</el-button
        >
        <el-button size="small" @click="cancelEdit">取消</el-button>
      </template>
    </QS-scroller-box>
  </div>
</template>

<script>
import carInfo from './components/carInfo.vue'
// eslint-disable-next-line import/no-cycle
import {
  getLeaseDetail,
  doLeaseOrderEdit,
} from '@/api/purchaseAndSaleAPI'
import selectOption from '@/store/dict/selectOptionDict'
import detailPaymentInfo from '@/pages/orders/enterpriseOrder/components/detailPaymentInfo.vue'
import detailReceivableInfo from '@/pages/orders/enterpriseOrder/components/detailReceivableInfo.vue'

export default {
  components: {
    carInfo,
    detailPaymentInfo,
    detailReceivableInfo,
  },
  data() {
    return {
      orderState: {
        1: '已创建',
        2: '进行中',
        3: '已关闭',
      },
      btnLoading: false,
      isEdit: false,
      // 订单信息
      baseInfoList: [
        {
          key: 'id',
          name: '订单ID',
        },
        {
          key: 'typeName',
          name: '订单类型',
        },
        {
          key: 'state',
          name: '订单状态',
        },
        {
          key: 'customerName',
          name: '客户',
        },
        {
          key: 'customerId',
          name: '客户ID',
        },
        {
          key: 'gmtCreate',
          name: '订单创建时间',
        },
        {
          key: 'contractStartDate',
          name: '合同开始日期',
        },
        {
          key: 'contractEndDate',
          name: '合同结束日期',
        },
        {
          key: 'deposit',
          name: '总押金',
        },
        {
          key: 'manageFee',
          name: '一次性管理费',
        },
        {
          key: 'serviceFee',
          name: '其他服务费',
        },
        {
          key: 'contractNo',
          name: '业务合同编号',
        },
        {
          key: 'remarks',
          name: '备注',
        },
      ],
      // 原订单信息
      oldEntOrderInfoList: [
        {
          key: 'contractStartDate',
          name: '合同开始日期',
        },
        {
          key: 'contractEndDate',
          name: '原合同结束日期',
        },
        {
          key: 'deposit',
          name: '总押金',
        },
        {
          key: 'manageFee',
          name: '一次性管理费',
        },
        {
          key: 'serviceFee',
          name: '其他服务费',
        },
        {
          key: 'contractNo',
          name: '业务合同编号',
        },
        {
          key: 'remarks',
          name: '备注',
        },
      ],
      oldEntOrderInfoes: [],
      // 采购订单基本信息右侧内容
      baseInfo: {
        state: null,
        attachment: [],
      },

      // 保存当前ID
      detailsId: null,
    }
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
  },
  mounted() {
    const { id } = this.$route.query
    if (!id) {
      this.$message.error('请携带必要参数')
      this.$router.go(-1)
    }
    this.detailsId = String(id)
    this.getPageData()
  },
  methods: {


    // 合同保存按钮
    async doSave() {
      this.btnLoading = true
      const { code, data } = await doLeaseOrderEdit({
        orderId: Number(this.detailsId),
        orderNo: this.baseInfo.orderNo, // 合同编号
        attachment: this.getUoloadCommonFileData(this.baseInfo.attachment),
      })
      if (code === 1) {
        if (data) {
          this.btnLoading = false
          this.$message({
            message: '保存成功',
            type: 'success',
          })
          // 刷新页面数据
          this.getPageData()
          this.isEdit = false
        }
      } else {
        this.btnLoading = false
        this.$message.error('保存失败请再次尝试')
      }
    },
    cancelEdit() {
      this.isEdit = false
    },

    handle() {
      // 订单类型
      const type = selectOption.typeofcontractDict[this.baseInfo.type]
      const purchaseType =
        selectOption.purchaseTypeDict[this.baseInfo.purchaseType]
      const state = this.orderState[this.baseInfo.state] // 订单状态
      const attachment = this.getEchoUploadFileData(this.baseInfo.attachment)
      this.baseInfo = {
        ...this.baseInfo,
        type,
        purchaseType,
        state,
        attachment,
      }
    },

    // 详情页请求数据
    async getDetails() {
      // try {
      const { code, data } = await getLeaseDetail({
        id: Number(this.detailsId),
      })
      if (code !== 1 || !data) return

      this.baseInfo = data.orderInfo // 订单基本信息
      this.baseInfo.contractAttachment = this.getEchoUploadFileData(data.orderInfo.contractAttachment, true)
      this.oldEntOrderInfoes = data.oldEntOrderInfoList || [] // 原订单信息
      this.oldEntOrderInfoes?.forEach((item) => {
        item.contractAttachment = this.getEchoUploadFileData(item.contractAttachment || '[]', true)
      })
      // 如果存在原订单信息，修改订单信息“合同结束日期”为“续约后合同结束日期”
      if (data.oldEntOrderInfoList.length) {
        this.baseInfoList.forEach((item) => {
          if (item.key === 'contractEndDate') {
            item.name = '续约后合同结束日期'
          }
        })
      }
      this.baseInfo.typeName = '企业订单'
      this.handle()
    },
    getPageData() {
      this.getDetails() // 订单详情
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
.details {
  min-height: 1422px;
  .details_content {
    .details_content_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .purchase {
        margin: 0;
      }
      h3 {
        font-family: PingFangSC-Medium;
        font-size: 20px;
        color: #323233;
        font-weight: 500;
        margin: 0;
      }
    }
    .details_content_repeat {
      margin-bottom: 16px;
      ::v-deep .qs-h4-container-left {
        font-size: 16px;
      }
      .details_content_repeat_hundred {
        // margin-left: 100px;
        ::v-deep .column-title {
          text-align: right;
          padding-right: 10px;
          color: #333333;
          min-width: 115px !important;
        }
        .enclosure {
          ::v-deep .el-form-item__label {
            width: 117px !important;
          }
        }
      }
    }
    // 文件图标颜色
    .uptext {
      .blue {
        color: #2e7eff;
        display: inline-block;
        margin: 0;
      }
    }
  }
  .i-title-box {
    position: relative;
    .i-title-btn {
      position: absolute;
      top: 4px;
      right: 0;
    }
  }
  .txt-right {
    text-align: right;
  }
}
</style>
